//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CrashNotifications',
  props: {
    // 游戏状态对象: { id: number, status: 'CREATED' | 'STARTED' | 'CRASHED' | 'ENDED' }
    game: {
      type: Object,
      default: () => null
    },
    // 下注列表映射: Record<number, Bet>
    bets: {
      type: Object,
      default: () => ({})
    },
    // 当前游戏倍率
    currentRatio: {
      type: Number,
      default: 1.0
    },
    // 是否开启主播模式 (隐匿敏感数据)
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MAX: 3,
      toasts: [],
      queue: [],
      isProcessingQueue: false,
      pushedIds: new Set(),
      initialLoad: true,
      lastCashedAt: 0,
      currentGameId: null,
      slideRightTimeouts: new Set(),
      clearTimer: null,
      defaultAvatar: require(`@/assets/images/user/ava_none.jpg`),
      gunSvgUrl: require('../../assets/gun.svg'),
      CRASH_DEMO_RATIOS: [1.5, 2.0, 3.0] // 示例 demo 临界倍率
    };
  },
  watch: {
    game: {
      deep: true,
      immediate: true,
      handler(game) {
        if (!game) return;

        this.currentGameId = game.id ?? this.currentGameId;

        if (game.status === 'Starting') {
          this.stopRound();
          this.resetState();
          this.clear();
          this.currentGameId = game.id ?? this.currentGameId;
          return;
        }

        if (game.status === 'Crash' || game.status === 'Over') {
          this.stopRound();
          this.resetState();

          if (this.clearTimer) clearTimeout(this.clearTimer);
          this.clearTimer = setTimeout(() => {
            this.clear();
          }, 3000);
          return;
        }

        if (game.status === 'InProgress') {
          this.checkBets();
        }
      }
    },
    bets: {
      deep: true,
      handler() {
        if (this.game && this.game.status === 'InProgress') {
          this.checkBets();
        }
      }
    },
    currentRatio() {
      if (this.game && this.game.status === 'InProgress') {
        this.checkBets();
      }
    }
  },
  beforeDestroy() {
    this.stopRound();
    this.clearSlideRightTimeouts();
  },
  methods: {
    // 检查是否有新中奖（逃顶）的用户
    checkBets() {
      const betsMap = JSON.parse(JSON.stringify(this.bets || {}));

      const won = Object.values(betsMap)
        .filter(
          (b) =>
            b.stoppedAt != null &&
            (b.gameId != null && this.currentGameId != null
              ? b.gameId === this.currentGameId
              : true)
        )
        .sort((a, b) => a.stoppedAt - b.stoppedAt);

      if (this.initialLoad) {
        if (won.length > 0) {
          const batch = won.slice(-3);

          batch.forEach((b) => {
            this.pushedIds.add(b.id);
            this.enqueueNotification(this.toNotif(b));
          });
          this.lastCashedAt = batch[batch.length - 1].stoppedAt;
          this.initialLoad = false;
        }
        return;
      }

      for (const b of won) {
        if (b.stoppedAt > this.lastCashedAt && !this.pushedIds.has(b.id)) {
          this.pushedIds.add(b.id);
          this.enqueueNotification(this.toNotif(b));

          if (b.stoppedAt > this.lastCashedAt) {
            this.lastCashedAt = b.stoppedAt;
          }
        }
      }
    },

    // 加入消费队列
    enqueueNotification(notif) {
      this.queue.push(notif);
      this.processQueue();
    },

    async processQueue() {
      if (this.isProcessingQueue) return;
      this.isProcessingQueue = true;

      while (this.queue.length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (this.queue.length > 0) {
          const n = this.queue.shift();
          this.doPush(n);
        }
      }

      this.isProcessingQueue = false;
    },

    // 推送消息进 Toast 视图列表
    doPush(n) {
      if (this.toasts.length >= this.MAX) {
        const updatedArr = [...this.toasts];

        // 将最后一个设为向右滑出标志
        const lastIndex = updatedArr.length - 1;
        this.$set(updatedArr, lastIndex, {
          ...updatedArr[lastIndex],
          slideRight: true
        });

        this.toasts = [n, ...updatedArr];

        const timeoutId = setTimeout(() => {
          this.slideRightTimeouts.delete(timeoutId);
          this.toasts = this.toasts.filter((item) => !item.slideRight);
        }, 320);

        this.slideRightTimeouts.add(timeoutId);
      } else {
        this.toasts = [n, ...this.toasts];
      }
    },

    stopRound() {
      this.queue = [];
      if (this.clearTimer) {
        clearTimeout(this.clearTimer);
        this.clearTimer = null;
      }
    },

    resetState() {
      this.clearSlideRightTimeouts();
      this.pushedIds.clear();
      this.initialLoad = true;
      this.lastCashedAt = 0;
    },

    clear() {
      this.clearSlideRightTimeouts();
      this.toasts = [];
    },

    clearSlideRightTimeouts() {
      this.slideRightTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));
      this.slideRightTimeouts.clear();
    },

    toNotif(b) {
      return {
        id: b.id,
        name: b.name,
        multiplier: b.stoppedAt,
        avatar: b.avatar
      };
    },

    // 管道替代方法
    getAvatarUrl(url) {
      return url || this.defaultAvatar;
    },

    formatMultiplier(val) {
      return `x${val}`;
    }
  }
};
